/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Modal, Input, message, Tooltip } from 'antd'
import { useNavigate } from 'react-router-dom'
import { FiArrowRight, FiTag, FiShoppingBag, FiCreditCard, FiDollarSign, FiX } from 'react-icons/fi'
import { SiMercadopago, SiPaypal } from 'react-icons/si'
import { useSelector, useDispatch } from 'react-redux'
import { motion, AnimatePresence } from 'framer-motion'

import { 
  CartHeader, 
  CartTitle, 
  CurrencySwitcher, 
  CurrencyButton,
  CartBody, 
  EmptyCart,
  CartFooter, 
  CartTotal,
  SubtotalRow,
  DiscountRow,
  TotalRow,
  CheckoutButton,
  CouponLink,
  PaymentMethodSelector,
  PaymentMethod
} from './styles'

import CartItem from '../CartItem'

import convertCurrency from '../../services/currency'
import { setCurrency } from '../../store/actions/cart.actions'

import { isLogged } from '../../guard'

import api from '../../services/api'

export default function Cart({ onCloseCart }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [visible, setVisible] = useState(false)
  const [cupomLoading, setCupomLoading] = useState(false)
  const [cupom, setCupom] = useState('')
  const [discount, setDiscount] = useState(null)
  const [gateway, setGateway] = useState('MERCADOPAGO')
  const [loading, setLoading] = useState(false)
  const [promotionals, setPromotionals] = useState(0)
  const [subtotal, setSubtotal] = useState(0)

  const cart = useSelector((state) => state.cart)

  useEffect(() => {
    recalc()
  }, [cart])

  async function recalc() {
    var total = 0
    var promotionals = 0

    cart.products.map((product) => {
      total = total + product.price

      if (product.licenses.length > 1) {
        total = total + (product.licenses.length - 1) * 5
      }
      if (product.promotional > 0) {
        promotionals += product.price
      }
      return true
    })

    if (total === 0) {
      return setSubtotal(total)
    }

    if (cart.currency !== 'BRL') {
      total = await convertCurrency({
        amount: total,
        from: 'BRL',
        to: cart.currency,
      })
      promotionals = await convertCurrency({
        amount: promotionals,
        from: 'BRL',
        to: cart.currency,
      })
    }

    setPromotionals(promotionals)
    setSubtotal(total)
  }

  async function apply() {
    if (cupom.length === 0) return false

    setCupomLoading(true)

    try {
      setCupom('')
      const result = await api.get(`/discount/${cupom}`)

      if (result.data && result.data.message) {
        setCupom('')
        setCupomLoading(false)
        message.info('Este cupom não foi encontrado ou expirou ou atingiu o máximo de usos.')
        return false
      }

      const { amount, type } = result.data

      if (type === 'AMOUNT') {
        if (amount >= subtotal) {
          setCupomLoading(false)
          return message.warning(
            `Valor mínimo de compra é de R$${parseFloat(amount).toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          )
        }
      }

      if (cart.products.some((product) => product.promotional)) {
        cart.products.forEach((product) => {
          console.log(product)
        })
        message.info('Atenção, alguns produtos não receberam desconto pois já contém seus preços em promoção.')
      }

      setDiscount(result.data)
    } catch (err) {
      message.error(err.response.data.message)
    }
    setVisible(false)
    setCupomLoading(false)
  }

  async function pay() {
    setLoading(true)

    try {
      const {
        data: { link },
      } = await api.post(`/checkout/pay/${gateway}`, {
        products: cart.products,
        cupom,
        discount,
      })
      window.location.href = link
    } catch (err) {
      message.error('Ocorreu um erro ao processar sua transação, por favor tente novamente mais tarde.')
    }

    setLoading(false)
  }

  function getDiscount() {
    if (!discount)
      return {
        subtotal,
        amount: 0,
      }

    if (discount.type === 'AMOUNT') {
      return {
        subtotal: subtotal - promotionals - discount.amount + promotionals,
        amount: discount.amount,
      }
    }

    if (subtotal === 0)
      return {
        subtotal,
        amount: 0,
      }

    var minus = ((subtotal - promotionals) * discount.amount) / 100

    return {
      subtotal: subtotal - promotionals - minus + promotionals,
      amount: minus,
    }
  }

  const { subtotal: finalValue, amount: discountAmount } = getDiscount()
  const currencySymbol = cart.currency === 'BRL' ? 'R$' : cart.currency === 'USD' ? '$' : '€';

  return (
    <React.Fragment>
      <Modal
        title="Aplicar cupom de desconto"
        visible={visible}
        onOk={apply}
        onCancel={() => setVisible(false)}
        okButtonProps={{ loading: cupomLoading }}
        okText="Aplicar"
        cancelText="Cancelar"
      >
        <Input
          size="large"
          placeholder="Digite seu cupom"
          value={cupom}
          onChange={(e) => setCupom(e.target.value)}
          prefix={<FiTag />}
        />
      </Modal>
      
      <CartHeader>
        <CartTitle>
          <motion.h2
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            Meu Carrinho
            <span>{cart.products.length} {cart.products.length === 1 ? 'item' : 'itens'}</span>
          </motion.h2>
          <motion.button 
            className="close-button"
            onClick={() => onCloseCart()}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiX />
          </motion.button>
        </CartTitle>
        
        <CurrencySwitcher>
          <CurrencyButton
            active={cart.currency === 'BRL'}
            onClick={() => {
              dispatch(setCurrency('BRL'))
              setGateway('MERCADOPAGO')
            }}
          >
            BRL
          </CurrencyButton>
          <CurrencyButton
            active={cart.currency === 'USD'}
            onClick={() => {
              dispatch(setCurrency('USD'))
              setGateway('PAYPAL')
            }}
          >
            USD
          </CurrencyButton>
          <CurrencyButton
            active={cart.currency === 'EUR'}
            onClick={() => {
              dispatch(setCurrency('EUR'))
              setGateway('PAYPAL')
            }}
          >
            EUR
          </CurrencyButton>
        </CurrencySwitcher>
      </CartHeader>
      
      <CartBody>
        <AnimatePresence>
          {cart.products.length > 0 ? (
            cart.products.map((product) => (
              <motion.div
                key={`product-${product.id}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.3 }}
              >
                <CartItem image={product.image} data={product} />
              </motion.div>
            ))
          ) : (
            <EmptyCart>
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <FiShoppingBag />
                <h3>Seu carrinho está vazio</h3>
                <p>Adicione alguns produtos para começar.</p>
              </motion.div>
            </EmptyCart>
          )}
        </AnimatePresence>
      </CartBody>
      
      {cart.products.length > 0 && (
        <CartFooter>
          <CartTotal>
            <SubtotalRow>
              <span>Subtotal</span>
              <span>{currencySymbol} {parseFloat(subtotal).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</span>
            </SubtotalRow>
            
            {discount && (
              <DiscountRow>
                <div>
                  <span>Desconto</span>
                  <CouponLink onClick={(e) => {
                    e.preventDefault()
                    setDiscount(null)
                    setCupom('')
                  }}>
                    remover
                  </CouponLink>
                </div>
                <span>- {currencySymbol} {parseFloat(discountAmount).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</span>
              </DiscountRow>
            )}
            
            <TotalRow>
              <span>Total</span>
              <span>{currencySymbol} {parseFloat(finalValue).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</span>
            </TotalRow>
            
            {!discount && (
              <CouponLink
                className="add-coupon"
                onClick={(e) => {
                  e.preventDefault()
                  setVisible(true)
                }}
              >
                <FiTag /> Adicionar cupom de desconto
              </CouponLink>
            )}
          </CartTotal>
          
          <PaymentMethodSelector>
            <h4>Método de Pagamento</h4>
            <div>
              {cart.currency === 'BRL' && (
                <PaymentMethod 
                  active={gateway === 'MERCADOPAGO'} 
                  onClick={() => setGateway('MERCADOPAGO')}
                  as={motion.button}
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                  title="MercadoPago"
                  aria-label="MercadoPago"
                >
                  <SiMercadopago style={{ paddingLeft: '2px', color: 'white' }}/>
                  <span>MercadoPago</span>
                </PaymentMethod>
              )}
              
              <PaymentMethod 
                active={gateway === 'PAYPAL'} 
                onClick={() => setGateway('PAYPAL')}
                as={motion.button}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
                title="PayPal"
                aria-label="PayPal"
              >
                <SiPaypal />
                <span>PayPal</span>
              </PaymentMethod>
              
              <PaymentMethod 
                active={gateway === 'PIX'} 
                onClick={() => setGateway('PIX')}
                as={motion.button}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
                disabled={cart.currency !== 'BRL'}
                title="PIX"
                aria-label="PIX"
              >
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
<path fill="#4db6ac" d="M11.9,12h-0.68l8.04-8.04c2.62-2.61,6.86-2.61,9.48,0L36.78,12H36.1c-1.6,0-3.11,0.62-4.24,1.76	l-6.8,6.77c-0.59,0.59-1.53,0.59-2.12,0l-6.8-6.77C15.01,12.62,13.5,12,11.9,12z"></path><path fill="#4db6ac" d="M36.1,36h0.68l-8.04,8.04c-2.62,2.61-6.86,2.61-9.48,0L11.22,36h0.68c1.6,0,3.11-0.62,4.24-1.76	l6.8-6.77c0.59-0.59,1.53-0.59,2.12,0l6.8,6.77C32.99,35.38,34.5,36,36.1,36z"></path><path fill="#4db6ac" d="M44.04,28.74L38.78,34H36.1c-1.07,0-2.07-0.42-2.83-1.17l-6.8-6.78c-1.36-1.36-3.58-1.36-4.94,0	l-6.8,6.78C13.97,33.58,12.97,34,11.9,34H9.22l-5.26-5.26c-2.61-2.62-2.61-6.86,0-9.48L9.22,14h2.68c1.07,0,2.07,0.42,2.83,1.17	l6.8,6.78c0.68,0.68,1.58,1.02,2.47,1.02s1.79-0.34,2.47-1.02l6.8-6.78C34.03,14.42,35.03,14,36.1,14h2.68l5.26,5.26	C46.65,21.88,46.65,26.12,44.04,28.74z"></path>
</svg>
                <span>PIX</span>
              </PaymentMethod>
            </div>
          </PaymentMethodSelector>
          
          <CheckoutButton
            disabled={cart.products.length === 0}
            loading={loading}
            onClick={() => {
              if (!isLogged()) {
                message.warning('Você precisa estar logado para finalizar a compra')
                onCloseCart()
                return navigate('/login')
              }
              pay()
            }}
            as={motion.button}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Finalizar Compra <FiArrowRight />
          </CheckoutButton>
        </CartFooter>
      )}
    </React.Fragment>
  )
}
